import { differenceInYears } from 'date-fns';

/**
 * Takes a date string and return the age
 *
 * @param dateString e.g. 19-06-1970
 *
 */

export default function getAge(dateString) {
  if (!dateString) {
    return undefined;
  }
  // converting 'dd-mm-yyyy' to 'yyyy-mm-dd'
  const convertedDate = dateString
    .split(/\//)
    .reverse()
    .join('/');

  const birthDate = new Date(convertedDate);
  return differenceInYears(new Date(), birthDate);
}
